export default theme => ({
  button: {
    color: "black",
    borderColor: theme.palette.white.main,
    background: theme.palette.white.main,
    borderStyle: "hidden",
  },
  alignedLink__externalLink__text: {
    display: "inline-block",
    marginLeft: 10,
    verticalAlign: "super",
  },
  toolButton: {
    width: "100%",
  },
  toolButton_text__small: {
    "& a": {
      fontSize: theme.textSizes[0],
    },
  },
  warning: {
    marginTop: 20,
  },
});
